import axios from 'axios';

import { useServicerStore } from '../store';

const ReportService = {
  async getPayoffLetter({ loanId, formValues }) {
    const response = await axios.get(
      `/report/loan/${loanId}/payoff_statement`,
      {
        params: formValues,
      }
    );

    return response.data;
  },

  async getWelcomeLetter(loanId) {
    const response = await axios.get(`/report/loan/${loanId}/welcome`);

    return response.data;
  },

  async getWelcomeLetter2(loanId) {
    const response = await axios.get(`/report/${loanId}/welcome_letter`);

    return response.data;
  },

  async getDueInvoices() {
    const response = await axios.get('/report/invoices/due');

    return response.data;
  },

  async getLateInvoices() {
    const response = await axios.get('/report/invoices/late', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },

  async getUnappliedPayments() {
    const response = await axios.get('/report/payments/unapplied', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },

  async getUndepositedChecks() {
    const response = await axios.get('/report/undeposited_checks', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },

  async getLoanPaymentHistory(loanId) {
    const response = await axios.get(`/report/loan/${loanId}/payment_history`);

    return response.data;
  },

  async getLoansPendingReport() {
    const response = await axios.get('/report/loan/pending');

    return response.data;
  },

  async getImpoundStatement(loanId) {
    const response = await axios.get(`/report/${loanId}/impound_statement`);

    return response.data;
  },

  async getInsuraceAlerts() {
    const response = await axios.get('/report/insurance/audit', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },

  async getLenderInsurancesReport(lenderId) {
    const response = await axios.get(`/report/lender/${lenderId}/insurance`);

    return response.data;
  },

  async getPaymentsDue() {
    const response = await axios.get('/report/invoices/due', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },

  async getTaxAuditReport(taxYear) {
    const response = await axios.get('/report/tax/audit', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
        tax_year: taxYear || null,
      },
    });

    return response.data;
  },

  async getPaymentHistory(loanId) {
    const response = await axios.get(`/report/loan/${loanId}/payment_history`);

    return response.data;
  },

  async getDemandsReport() {
    const response = await axios.get('/report/demands', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },

  async getAccelerationPackage(loanId) {
    const response = await axios.get(`/report/loan/${loanId}/acceleration`);

    return response.data;
  },

  async getUnmatchedSettlements() {
    const response = await axios.get('/report/billcom_settlements_missing');

    return response.data;
  },

  async getUnclearedBillComVendorChecks() {
    const response = await axios.get(
      '/report/uncleared_billcom_vendor_checks',
      {
        params: { servicer_id: useServicerStore.getState()?.servicerId },
      }
    );

    return response.data;
  },

  async getDemandAccelerationPackage(demandId) {
    const response = await axios.get(`/report/demand/${demandId}/acceleration`);

    return response.data;
  },

  async getPayoffs() {
    const response = await axios.get('/report/payoff_requests', {
      params: { servicer_id: useServicerStore.getState()?.servicerId },
    });

    return response.data;
  },
};

export default ReportService;
